var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field-tooltip w-100 d-flex",class:`justify-content-${_vm.position}`},[_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.right.html",value:({
      customClass: 'field-tooltip custom-tooltip max-width-190 default-cursor',
      title: _vm.info,
      fallbackPlacement: 'counterclockwise',
      boundary: 'viewport',
    }),expression:"{\n      customClass: 'field-tooltip custom-tooltip max-width-190 default-cursor',\n      title: info,\n      fallbackPlacement: 'counterclockwise',\n      boundary: 'viewport',\n    }",modifiers:{"hover":true,"right":true,"html":true}}],staticClass:"pr-12"},[_vm._v(" "+_vm._s(_vm.option.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }